import React, { useEffect, useRef, useState } from "react";
import { giftCategories } from '../mockData';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import ContactSlideout from '../components/ContactSlideout';
import ShareListModal from "../components/share/ShareListModal";
import CoupleDashboardHeader from "../components/CoupleDashboardHeader";
import OnboardingWizard from '../components/OnboardingWizard';
import DashboardTabs from '../components/dashboard/DashboardTabs';
import DashboardFooter from '../components/dashboard/DashboardFooter';
import GiftFormModal from '../components/dashboard/modals/GiftFormModal';
import PasswordChangeModal from '../components/dashboard/modals/PasswordChangeModal';
import SecurityTab from '../components/dashboard/tabs/SecurityTab';
import ThankYouModal from '../components/ThankYouModal';
import BankingTab from '../components/dashboard/tabs/BankingTab';
import ReceivedTab from '../components/dashboard/tabs/ReceivedTab';

import { useSearchParams } from 'react-router-dom';

const API_ENDPOINTS = {
  giftGetCoupleData: 'https://gift-getcouplesdata-336444799661.us-central1.run.app',
  giftUpdateSetup: 'https://gift-updatesetup-336444799661.us-central1.run.app',
  giftUpdateBanking: 'https://gift-updatebanking-336444799661.us-central1.run.app',
  giftGetCoupleGifts: 'https://gift-getcouplesgift-336444799661.us-central1.run.app/giftGetCoupleGifts',
  giftGetReceivedGifts: 'https://gift-getreceivedgifts-336444799661.us-central1.run.app',
  giftCreateCoupleGift: 'https://gift-createcouplegift-336444799661.us-central1.run.app',
  giftUpdateCoupleGift: 'https://gift-updatecouplegift-336444799661.us-central1.run.app',
  giftDeleteCoupleGift: 'https://gift-deletecouplegift-336444799661.us-central1.run.app',
  giftToggleGiftActive: 'https://gift-togglegiftactive-336444799661.us-central1.run.app',
  giftUploadProfileImage: 'https://gift-uploadprofileimage-336444799661.us-central1.run.app',
  giftUpdateCouple: 'https://gift-updatecouple-336444799661.us-central1.run.app', // Para actualizar Firestore

};

// Al inicio del componente CoupleDashboard, después de los imports
const capitalizeText = (text) => {
  if (!text) return '';
  return text
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};


const CoupleDashboard = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const receivedTopRef = useRef(null);
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [toast, setToast] = useState(null);

  // const [activeTab, setActiveTab] = useState('setup');
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'setup';
  const [giftsLoaded, setGiftsLoaded] = useState(false); // ✅ Nuevo estado
  const [uploadingProfileImage, setUploadingProfileImage] = useState(false);


  const setActiveTab = (newTab) => {
    setSearchParams({ tab: newTab });
    window.scrollTo({ top: 0, behavior: 'smooth' }); // ✅ Scroll suave al top
  };
  useEffect(() => {
    if (activeTab !== "received") return;

    const onScroll = () => setShowBackToTop(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [activeTab]);


  const [couple, setCouple] = useState(null);
  const [loading, setLoading] = useState(true);

  // Nuevos estados para gifts y received
  const [gifts, setGifts] = useState([]);
  const [receivedGifts, setReceivedGifts] = useState([]);
  const [loadingGifts, setLoadingGifts] = useState(false);
  const [loadingReceived, setLoadingReceived] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  // Nuevos estados para modales
  const [showGiftModal, setShowGiftModal] = useState(false);
  const [editingGift, setEditingGift] = useState(null);
  const [giftFormData, setGiftFormData] = useState({
    name: '',
    category: '',
    price: '',
    description: '',
    image: '',
  });
  const [selectedCategory, setSelectedCategory] = useState(null); // slug o null
  // ... thank you modal:
  const [showThankYouModal, setShowThankYouModal] = useState(false);
  const [selectedContributor, setSelectedContributor] = useState(null);
  const [selectedGift, setSelectedGift] = useState(null);
  const [setupData, setSetupData] = useState({
    ceremonyComplete: false,
    partyComplete: false,
  });

  const [bankingData, setBankingData] = useState({
    arsComplete: false,
    usdComplete: false
  });

  // En los estados, después de bankingData
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [passwordFormData, setPasswordFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const [searchQuery, setSearchQuery] = useState('');
  const [visibleCount, setVisibleCount] = useState(12);

  const [setupFormDirty, setSetupFormDirty] = useState(false);

  // --- Gifts tab: sort + bulk selection ---
  const [giftSort, setGiftSort] = useState({ key: 'name', dir: 'asc' }); // default elegante
  const [selectionMode, setSelectionMode] = useState(false);
  const [selectedGiftIds, setSelectedGiftIds] = useState(() => new Set());

  const toggleGiftSort = (key) => {
    setGiftSort((prev) => {
      if (prev.key === key) return { key, dir: prev.dir === 'asc' ? 'desc' : 'asc' };
      return { key, dir: 'asc' };
    });
  };

  const sortIcon = (key) => {
    if (giftSort.key !== key) return '↕';
    return giftSort.dir === 'asc' ? '↑' : '↓';
  };

  const normalize = (v) => (v ?? '').toString().toLowerCase();

  // ... handler:
  const handleOpenThankYou = (contributor, gift) => {
    setSelectedContributor(contributor);
    setSelectedGift(gift);
    setShowThankYouModal(true);
  };

  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(() => setToast(null), 4000);
    return () => clearTimeout(t);
  }, [toast]);


  useEffect(() => {
    if (activeTab === "received") setVisibleCount(12);
  }, [activeTab, searchQuery]);
  const [showShareModal, setShowShareModal] = useState(false)

  const [showOnboarding, setShowOnboarding] = useState(false);

  const refreshGifts = React.useCallback(async () => {
    // console.log('🔄 Iniciando refresh de gifts...');
    setLoadingGifts(true);

    try {
      const token = localStorage.getItem('token');

      // ✅ Agregar coupleId como query param
      const response = await fetch(`${API_ENDPOINTS.giftGetCoupleGifts}?coupleId=${couple.id}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      const data = await response.json();
      // console.log('📦 Respuesta de gifts:', data);

      if (data.success) {
        // console.log('✅ Actualizando gifts con:', data.data.length, 'items');
        setGifts(data.data);
      } else {
        console.error('❌ Error en respuesta:', data.error);
      }
    } catch (error) {
      console.error('❌ Error refreshing gifts:', error);
    } finally {
      setLoadingGifts(false);
    }
  }, [couple]); // ✅ Agregar couple como dependencia

  // Filtrar regalos por búsqueda (esta lógica fue movida a receivedGiftsFiltered)

  const receivedGiftsFiltered = gifts
    .filter(g => (g.amountReceived || 0) > 0)
    .filter(gift => {
      if (!searchQuery) return true;
      const query = searchQuery.toLowerCase();
      return (
        gift.name?.toLowerCase().includes(query) ||
        gift.contributors?.some(c =>
          (c.name || "").toLowerCase().includes(query) ||
          (c.email || "").toLowerCase().includes(query)
        )
      );
    });



  // Forzar wizard (temporal para testing)

  // Handler para cambiar contraseña
  // const handleChangePassword = async (e) => {
  //   e.preventDefault();

  //   if (passwordFormData.newPassword !== passwordFormData.confirmPassword) {
  //      setToast({
  //   type: "error",
  //   title: "Las contraseñas no coinciden",
  //   message: "Verificá que ambas contraseñas sean iguales.",
  // });
  //     return;
  //   }

  //   if (passwordFormData.newPassword.length < 8) {
  //      setToast({
  //   type: "error",
  //   title: "Contraseña muy corta",
  //   message: "La nueva contraseña debe tener al menos 8 caracteres.",
  // });
  //     return;
  //   }

  //   try {
  //     const token = localStorage.getItem('token');
  //     // ✅ Debug: verificar que el token existe
  //     // console.log('🔑 Token:', token ? 'Existe' : 'NO existe');

  //     const response = await fetch('https://gift-changepassword-336444799661.us-central1.run.app', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Authorization': `Bearer ${token}`
  //       },
  //       body: JSON.stringify({
  //         currentPassword: passwordFormData.currentPassword,
  //         newPassword: passwordFormData.newPassword,
  //       })
  //     });

  //     // ✅ Debug: ver respuesta completa
  //     // console.log('📥 Response status:', response.status);
  //     const data = await response.json();
  //     // console.log('📦 Response data:', data);

  //     if (data.success) {
  //       alert('✅ Contraseña cambiada exitosamente');
  //       setShowPasswordModal(false);
  //       setPasswordFormData({
  //         currentPassword: '',
  //         newPassword: '',
  //         confirmPassword: '',
  //       });
  //     } else {
  //       alert('❌ Error: ' + data.error);
  //     }
  //   } catch (error) {
  //     console.error('Error changing password:', error);
  //     alert('❌ Error al cambiar la contraseña');
  //   }
  // };

  const handleChangePassword = async (e) => {
    e.preventDefault();

    if (passwordFormData.newPassword !== passwordFormData.confirmPassword) {
      setToast({
        type: "error",
        title: "Las contraseñas no coinciden",
        message: "Verificá que ambas contraseñas sean iguales.",
      });
      return;
    }

    if (passwordFormData.newPassword.length < 8) {
      setToast({
        type: "error",
        title: "Contraseña muy corta",
        message: "La nueva contraseña debe tener al menos 8 caracteres.",
      });
      return;
    }

    const translatePasswordError = (err) => {
      const msg = (err || "").toLowerCase();

      if (msg.includes("current password is incorrect")) {
        return {
          title: "Contraseña actual incorrecta",
          message: "Revisá la contraseña actual e intentá de nuevo.",
        };
      }

      if (msg.includes("unauthorized") || msg.includes("invalid token") || msg.includes("token")) {
        return {
          title: "Sesión vencida",
          message: "Volvé a iniciar sesión e intentá nuevamente.",
        };
      }

      return {
        title: "No se pudo cambiar la contraseña",
        message: "Revisá los datos e intentá de nuevo.",
      };
    };

    try {
      const token = localStorage.getItem("token");

      const response = await fetch(
        "https://gift-changepassword-336444799661.us-central1.run.app",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            currentPassword: passwordFormData.currentPassword,
            newPassword: passwordFormData.newPassword,
          }),
        }
      );

      const data = await response.json();

      if (data.success) {
        setToast({
          type: "success",
          title: "Contraseña cambiada",
          message: "Listo ✅ Tu contraseña se actualizó correctamente.",
        });

        setShowPasswordModal(false);
        setPasswordFormData({
          currentPassword: "",
          newPassword: "",
          confirmPassword: "",
        });
        return;
      }

      // 👇 acá estaba saliendo el alert en inglés
      const t = translatePasswordError(data.error);
      setToast({ type: "error", ...t });
    } catch (error) {
      console.error("Error changing password:", error);
      setToast({
        type: "error",
        title: "Error al cambiar la contraseña",
        message: "Intentá nuevamente en unos segundos.",
      });
    }
  };

  //reset filter on tab gifts
  useEffect(() => {
    if (activeTab === "gifts") setSelectedCategory(null);
  }, [activeTab]);

  const visibleGifts = selectedCategory
    ? gifts.filter(g => g.category === selectedCategory)
    : gifts;

  // Fetch couple data on mount
  useEffect(() => {
    const fetchCoupleData = async () => {
      try {
        const token = localStorage.getItem('token');

        const response = await fetch(API_ENDPOINTS.giftGetCoupleData, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        const data = await response.json();

        if (data.success) {
          setCouple(data.data);

          setSetupData({
            ceremonyComplete: !!data.data.eventDetails?.ceremony?.location,
            partyComplete: !!data.data.eventDetails?.party?.location,
          });

          setBankingData({
            arsComplete: !!data.data.accountInfoARS?.cbu,
            usdComplete: !!data.data.accountInfoUSD?.cbu,
          });
        } else {
          alert('Error al cargar datos: ' + data.error);
        }
      } catch (error) {
        console.error('Error fetching couple data:', error);
        alert('Error al cargar datos');
      } finally {
        setLoading(false);
      }
    };

    fetchCoupleData();
  }, []);


  const sortedVisibleGifts = React.useMemo(() => {
    const arr = [...visibleGifts];

    const dir = giftSort.dir === 'asc' ? 1 : -1;

    arr.sort((a, b) => {
      // Empujar reservados al final? (opcional)
      // Si NO querés esto, borrá estas 3 líneas:
      // if (a.reserved !== b.reserved) return (a.reserved ? 1 : -1);

      switch (giftSort.key) {
        case 'name':
          return normalize(a.name).localeCompare(normalize(b.name)) * dir;

        case 'category':
          return normalize(a.category).localeCompare(normalize(b.category)) * dir;

        case 'price':
          return ((a.price || 0) - (b.price || 0)) * dir;

        case 'status': {
          // Disponible primero (0) / Recibido (1)
          const sa = a.reserved ? 1 : 0;
          const sb = b.reserved ? 1 : 0;
          return (sa - sb) * dir;
        }

        default:
          return 0;
      }
    });

    return arr;
  }, [visibleGifts, giftSort]);

  // Helpers selección
  const isSelectable = (gift) => !gift.reserved; // regla: no se puede borrar reservado

  const toggleSelectGift = (giftId) => {
    setSelectedGiftIds((prev) => {
      const next = new Set(prev);
      if (next.has(giftId)) next.delete(giftId);
      else next.add(giftId);
      return next;
    });
  };

  const clearSelection = () => setSelectedGiftIds(new Set());

  const selectedCount = selectedGiftIds.size;

  const eligibleVisibleIds = React.useMemo(() => {
    return sortedVisibleGifts.filter(isSelectable).map((g) => g.id);
  }, [sortedVisibleGifts]);

  const allVisibleSelected =
    eligibleVisibleIds.length > 0 &&
    eligibleVisibleIds.every((id) => selectedGiftIds.has(id));

  const toggleSelectAllVisible = () => {
    setSelectedGiftIds((prev) => {
      const next = new Set(prev);

      if (allVisibleSelected) {
        eligibleVisibleIds.forEach((id) => next.delete(id));
        return next;
      }

      eligibleVisibleIds.forEach((id) => next.add(id));
      return next;
    });
  };

  const handleBulkDelete = async () => {
    if (selectedGiftIds.size === 0) return;

    const ids = Array.from(selectedGiftIds);

    const confirmMsg =
      ids.length === 1
        ? '¿Seguro que querés eliminar 1 regalo?'
        : `¿Seguro que querés eliminar ${ids.length} regalos?`;

    if (!window.confirm(confirmMsg)) return;

    try {
      const token = localStorage.getItem('token');

      // Opcional: feedback
      // alert('🗑️ Eliminando...');

      const results = await Promise.allSettled(
        ids.map((giftId) =>
          fetch(API_ENDPOINTS.giftDeleteCoupleGift, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ giftId }),
          }).then((r) => r.json())
        )
      );

      const okIds = [];
      const failed = [];

      results.forEach((res, idx) => {
        const giftId = ids[idx];
        if (res.status === 'fulfilled' && res.value?.success) okIds.push(giftId);
        else failed.push(giftId);
      });

      if (okIds.length > 0) {
        setGifts((prev) => prev.filter((g) => !okIds.includes(g.id)));
      }

      clearSelection();
      setSelectionMode(false);

      if (failed.length > 0) {
        alert(`⚠️ Se eliminaron ${okIds.length}, pero fallaron ${failed.length}.`);
      } else {
        alert(`✅ Eliminados ${okIds.length} regalo${okIds.length === 1 ? '' : 's'}.`);
      }
    } catch (e) {
      console.error(e);
      alert('❌ Error al eliminar los regalos seleccionados');
    }
  };

  // Si salís de modo selección, limpiá selección
  useEffect(() => {
    if (!selectionMode) clearSelection();
  }, [selectionMode]);

  // Fetch couple's gifts cuando va al tab "gifts"
  // ✅ Fetch gifts al montar (necesario para tabs "gifts" y "received")
  // En el useEffect que carga gifts:
  // useEffect(() => {
  //   if (!loadingGifts && gifts.length === 0 && couple) { // ✅ Agregar && couple
  //     const fetchGifts = async () => {
  //       setLoadingGifts(true);
  //       try {
  //         const token = localStorage.getItem('token');

  //         // ✅ Agregar coupleId como query param
  //         const response = await fetch(`${API_ENDPOINTS.giftGetCoupleGifts}?coupleId=${couple.id}`, {
  //           headers: {
  //             'Authorization': `Bearer ${token}`
  //           }
  //         });

  //         const data = await response.json();

  //         if (data.success) {
  //           setGifts(data.data);
  //         } else {
  //           console.error('Error fetching gifts:', data.error);
  //         }
  //       } catch (error) {
  //         console.error('Error fetching gifts:', error);
  //       } finally {
  //         setLoadingGifts(false);
  //       }
  //     };

  //     fetchGifts();
  //   }
  // }, [couple, loadingGifts, gifts.length]); // ✅ Agregar todas las dependencias
  //   useEffect(() => {
  //     // ✅ Fetch solo si: (1) tenemos couple, (2) no hemos cargado aún, (3) estamos en el tab gifts
  // if (couple && !giftsLoaded && (activeTab === 'gifts' || activeTab === 'received' || activeTab === 'overview')) {
  //         const fetchGifts = async () => {
  //         setLoadingGifts(true);
  //         try {
  //           const token = localStorage.getItem('token');

  //           const response = await fetch(`${API_ENDPOINTS.giftGetCoupleGifts}?coupleId=${couple.id}`, {
  //             headers: {
  //               'Authorization': `Bearer ${token}`
  //             }
  //           });

  //           const data = await response.json();

  //           if (data.success) {
  //             setGifts(data.data || []); // ✅ Array vacío si no hay datos
  //           } else {
  //             console.error('Error fetching gifts:', data.error);
  //             setGifts([]); // ✅ Array vacío en caso de error
  //           }
  //         } catch (error) {
  //           console.error('Error fetching gifts:', error);
  //           setGifts([]); // ✅ Array vacío en caso de error
  //         } finally {
  //           setLoadingGifts(false);
  //           setGiftsLoaded(true); // ✅ Marcar como cargado
  //         }
  //       };

  //       fetchGifts();
  //     }
  //   }, [couple, giftsLoaded, activeTab]); // ✅ Dependencias correctas
  // Fetch couple data on mount
  useEffect(() => {
    const fetchCoupleData = async () => {
      try {
        const token = localStorage.getItem('token');

        // ✅ Cargar couple y gifts en paralelo
        const [coupleResponse, giftsResponse] = await Promise.all([
          fetch(API_ENDPOINTS.giftGetCoupleData, {
            headers: { 'Authorization': `Bearer ${token}` }
          }),
          // Necesitamos el coupleId, pero aún no lo tenemos...
          // Entonces primero cargamos couple
        ]);

        const coupleData = await coupleResponse.json();

        if (coupleData.success) {
          setCouple(coupleData.data);

          setSetupData({
            ceremonyComplete: !!coupleData.data.eventDetails?.ceremony?.location,
            partyComplete: !!coupleData.data.eventDetails?.party?.location,
          });

          setBankingData({
            arsComplete: !!coupleData.data.accountInfoARS?.cbu,
            usdComplete: !!coupleData.data.accountInfoUSD?.cbu,
          });

          // ✅ Cargar gifts inmediatamente con el coupleId
          const giftsRes = await fetch(
            `${API_ENDPOINTS.giftGetCoupleGifts}?coupleId=${coupleData.data.id}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
          );
          const giftsData = await giftsRes.json();

          if (giftsData.success) {
            setGifts(giftsData.data || []);
          }
          setGiftsLoaded(true);

        } else {
          alert('Error al cargar datos: ' + coupleData.error);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        alert('Error al cargar datos');
      } finally {
        setLoading(false);
        setLoadingGifts(false);
      }
    };

    fetchCoupleData();
  }, []);
  // Después de cargar couple:
  // useEffect(() => {
  //   if (couple && !couple.onboardingComplete) {
  //     setShowOnboarding(true);
  //   }
  // }, [couple]);



  // Fetch received gifts cuando va al tab "received"
  // useEffect(() => {
  //   if (activeTab === 'received' && !loadingReceived && receivedGifts.length === 0) {
  //     const fetchReceivedGifts = async () => {
  //       setLoadingReceived(true);
  //       try {
  //         const token = localStorage.getItem('token');

  //         const response = await fetch(API_ENDPOINTS.giftGetReceivedGifts, {
  //           headers: {
  //             'Authorization': `Bearer ${token}`
  //           }
  //         });

  //         const data = await response.json();

  //         if (data.success) {
  //           setReceivedGifts(data.data);
  //         } else {
  //           console.error('Error fetching received gifts:', data.error);
  //         }
  //       } catch (error) {
  //         console.error('Error fetching received gifts:', error);
  //       } finally {
  //         setLoadingReceived(false);
  //       }
  //     };

  //     fetchReceivedGifts();
  //   }
  // }, [activeTab]);
  // useEffect(() => {
  //   const fetchReceivedGifts = async () => {
  //     setLoadingReceived(true);
  //     try {
  //       const token = localStorage.getItem('token');

  //       const response = await fetch(API_ENDPOINTS.giftGetReceivedGifts, {
  //         headers: {
  //           'Authorization': `Bearer ${token}`
  //         }
  //       });

  //       const data = await response.json();
  //       console.log('📦 Received gifts response:', data); // ← ESTO te mostrará qué devuelve la API

  //       if (data.success) {
  //         setReceivedGifts(data.data);
  //       } else {
  //         console.error('Error fetching received gifts:', data.error);
  //       }
  //     } catch (error) {
  //       console.error('Error fetching received gifts:', error);
  //     } finally {
  //       setLoadingReceived(false);
  //     }
  //   };

  //   fetchReceivedGifts();
  // }, []); // ← SOLO ejecutar UNA VEZ al montar
  const fetchReceivedGifts = async () => {
    setLoadingReceived(true);
    try {
      const token = localStorage.getItem("token");

      const response = await fetch(API_ENDPOINTS.giftGetReceivedGifts, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      // console.log("📦 Received gifts response:", data);

      if (data.success) {
        setReceivedGifts(data.data);
      } else {
        console.error("Error fetching received gifts:", data.error);
      }
    } catch (error) {
      console.error("Error fetching received gifts:", error);
    } finally {
      setLoadingReceived(false);
    }
  };

  useEffect(() => {
    fetchReceivedGifts();
  }, []);

  const handleSetupFormChange = (e) => {
    // ✅ Ignorar cambios en el input de archivo
    if (e.target.type === 'file') return;

    if (!setupFormDirty) setSetupFormDirty(true);
  };


  // Handler para abrir modal de crear regalo
  const handleCreateGift = () => {
    setEditingGift(null);
    setGiftFormData({
      name: '',
      category: 'cocina',
      price: '',
      description: '',
      image: '',
    });
    setShowGiftModal(true);
  };

  // Handler para abrir modal de editar regalo
  const handleEditGift = (gift) => {
    setEditingGift(gift);
    setGiftFormData({
      name: gift.name,
      category: gift.category,
      price: gift.price,
      description: gift.description || '',
      image: gift.image || '',
    });
    setShowGiftModal(true);
  };

  // Handler para guardar regalo (crear o editar)
  // Handler para guardar regalo (crear o editar)
  // const handleSaveGift = async (e) => {
  //   e.preventDefault();

  //   try {
  //     const token = localStorage.getItem('token');
  //     const endpoint = editingGift
  //       ? API_ENDPOINTS.giftUpdateCoupleGift
  //       : API_ENDPOINTS.giftCreateCoupleGift;

  //     const body = editingGift
  //       ? { giftId: editingGift.id, ...giftFormData }
  //       : giftFormData;

  //     const response = await fetch(endpoint, {
  //       method: editingGift ? 'PUT' : 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Authorization': `Bearer ${token}`
  //       },
  //       body: JSON.stringify(body)
  //     });

  //     const data = await response.json();

  //     if (data.success) {
  //       alert(editingGift ? '✅ Regalo actualizado' : '✅ Regalo creado');
  //       setShowGiftModal(false);

  //       if (editingGift) {
  //         // ✅ Actualizar el regalo editado en el estado
  //         setGifts(gifts.map(g =>
  //           g.id === editingGift.id
  //             ? { ...g, ...giftFormData, price: parseFloat(giftFormData.price) }
  //             : g
  //         ));
  //       } else {
  //         // ✅ Agregar el nuevo regalo al estado
  //         const newGift = {
  //           id: data.giftId,
  //           ...giftFormData,
  //           price: parseFloat(giftFormData.price),
  //           reserved: false,
  //           active: true,
  //           coupleId: couple.id,
  //         };
  //         setGifts([...gifts, newGift]);
  //       }
  //     } else {
  //       alert('❌ Error: ' + data.error);
  //     }
  //   } catch (error) {
  //     console.error('Error saving gift:', error);
  //     alert('❌ Error al guardar el regalo');
  //   }
  // };
  const handleSaveGift = async (e, imageUrl = null) => {
    e.preventDefault();

    try {
      const token = localStorage.getItem('token');
      const endpoint = editingGift
        ? API_ENDPOINTS.giftUpdateCoupleGift
        : API_ENDPOINTS.giftCreateCoupleGift;

      // ✅ Si viene imageUrl del upload, actualizar formData con la nueva imagen
      const dataToSave = imageUrl
        ? { ...giftFormData, image: imageUrl }
        : giftFormData;

      const body = editingGift
        ? { giftId: editingGift.id, ...dataToSave }
        : dataToSave;

      const response = await fetch(endpoint, {
        method: editingGift ? 'PUT' : 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(body)
      });

      const data = await response.json();

      if (data.success) {
        alert(editingGift ? '✅ Regalo actualizado' : '✅ Regalo creado');
        setShowGiftModal(false);

        if (editingGift) {
          // ✅ Actualizar el regalo editado en el estado (con la nueva imagen si existe)
          setGifts(gifts.map(g =>
            g.id === editingGift.id
              ? { ...g, ...dataToSave, price: parseFloat(dataToSave.price) }
              : g
          ));
        } else {
          // ✅ Agregar el nuevo regalo al estado (con la imagen si existe)
          const newGift = {
            id: data.giftId,
            ...dataToSave,
            price: parseFloat(dataToSave.price),
            reserved: false,
            active: true,
            coupleId: couple.id,
          };
          setGifts([...gifts, newGift]);
        }
      } else {
        alert('❌ Error: ' + data.error);
      }
    } catch (error) {
      console.error('Error saving gift:', error);
      alert('❌ Error al guardar el regalo');
    }
  };

  // Handler para eliminar regalo
  const handleDeleteGift = async (giftId) => {
    if (!window.confirm('¿Seguro que querés eliminar este regalo?')) {
      return;
    }

    try {
      const token = localStorage.getItem('token');

      const response = await fetch(API_ENDPOINTS.giftDeleteCoupleGift, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ giftId })
      });

      const data = await response.json();

      if (data.success) {
        alert('✅ Regalo eliminado');
        // Actualizar lista
        setGifts(gifts.filter(g => g.id !== giftId));
      } else {
        alert('❌ Error: ' + data.error);
      }
    } catch (error) {
      console.error('Error deleting gift:', error);
      alert('❌ Error al eliminar el regalo');
    }
  };

  // Handler para toggle active
  const handleToggleActive = async (giftId, currentActive) => {
    try {
      const token = localStorage.getItem('token');

      const response = await fetch(API_ENDPOINTS.giftToggleGiftActive, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          giftId,
          active: !currentActive
        })
      });

      const data = await response.json();

      if (data.success) {
        // Actualizar lista
        setGifts(gifts.map(g =>
          g.id === giftId ? { ...g, active: !currentActive } : g
        ));
      } else {
        alert('❌ Error: ' + data.error);
      }
    } catch (error) {
      console.error('Error toggling active:', error);
      alert('❌ Error al cambiar estado');
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-neutral-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent-500"></div>
      </div>
    );
  }

  if (!couple) {
    return (
      <div className="min-h-screen bg-neutral-50 flex items-center justify-center">
        <div className="text-center">
          <p className="text-xl text-neutral-600">No se encontraron datos</p>
          <button onClick={() => navigate('/')} className="btn-primary mt-4">
            Volver al inicio
          </button>
        </div>
      </div>
    );
  }


  const calculateSetupProgress = () => {
    const fields = Object.values(setupData);
    const completed = fields.filter(Boolean).length;
    return Math.round((completed / fields.length) * 100);
  };

  const isSetupComplete = () => calculateSetupProgress() === 100;

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  // Handler para guardar Setup
  const handleSaveSetup = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);

    // ✅ Validar fechas
    const ceremonyDate = formData.get('ceremonyDate');
    const partyDate = formData.get('partyDate');
    const today = new Date().toISOString().split('T')[0];

    if (ceremonyDate && ceremonyDate < today) {
      alert('❌ La fecha de la ceremonia no puede ser en el pasado');
      return;
    }

    if (partyDate && partyDate < today) {
      alert('❌ La fecha de la fiesta no puede ser en el pasado');
      return;
    }

    // ✅ Validar que la fiesta no sea antes que la ceremonia (opcional)
    if (ceremonyDate && partyDate && partyDate < ceremonyDate) {
      const confirm = window.confirm('⚠️ La fiesta es antes que la ceremonia. ¿Está correcto?');
      if (!confirm) return;
    }

    try {
      const token = localStorage.getItem('token');

      const response = await fetch(API_ENDPOINTS.giftUpdateSetup, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        // body: JSON.stringify({
        //   ceremonyDate: formData.get('ceremonyDate'),
        //   ceremonyLocation: formData.get('ceremonyLocation'),
        //   ceremonyAddress: formData.get('ceremonyAddress'),
        //   ceremonyTime: formData.get('ceremonyTime'),
        //   ceremonyDetails: formData.get('ceremonyDetails'),
        //   partyDate: formData.get('partyDate'),
        //   partyLocation: formData.get('partyLocation'),
        //   partyAddress: formData.get('partyAddress'),
        //   partyTime: formData.get('partyTime'),
        //   partyDetails: formData.get('partyDetails'),
        // })
        body: JSON.stringify({
          ceremonyDate: formData.get('ceremonyDate'),
          ceremonyLocation: capitalizeText(formData.get('ceremonyLocation')), // ✅ Capitalizar
          ceremonyAddress: capitalizeText(formData.get('ceremonyAddress')), // ✅ Capitalizar
          ceremonyTime: formData.get('ceremonyTime'),
          ceremonyDetails: formData.get('ceremonyDetails'), // Dejar como está
          partyDate: formData.get('partyDate'),
          partyLocation: capitalizeText(formData.get('partyLocation')), // ✅ Capitalizar
          partyAddress: capitalizeText(formData.get('partyAddress')), // ✅ Capitalizar
          partyTime: formData.get('partyTime'),
          partyDetails: formData.get('partyDetails'), // Dejar como está
        })
      });

      const data = await response.json();

      if (data.success) {
        alert('✅ Datos guardados exitosamente');
        setSetupFormDirty(false);  // ✅ Agregar esto

        // setSetupData({
        //   ceremonyComplete: !!(formData.get('ceremonyLocation') && formData.get('ceremonyAddress')),
        //   partyComplete: !!(formData.get('partyLocation') && formData.get('partyAddress')),
        // });

        // window.location.reload();
        // Actualizar estados locales
        setSetupData({
          ceremonyComplete: !!(formData.get('ceremonyLocation') && formData.get('ceremonyAddress')),
          partyComplete: !!(formData.get('partyLocation') && formData.get('partyAddress')),
        });

        // Actualizar el objeto couple con los nuevos datos
        setCouple(prev => ({
          ...prev,
          weddingDate: formData.get('ceremonyDate') || prev.weddingDate,
          eventDetails: {
            ceremony: {
              date: formData.get('ceremonyDate'),  // ✅ AGREGAR
              location: capitalizeText(formData.get('ceremonyLocation')),
              address: capitalizeText(formData.get('ceremonyAddress')),
              time: formData.get('ceremonyTime'),
              details: formData.get('ceremonyDetails'),
            },
            party: {
              date: formData.get('partyDate'),  // ✅ AGREGAR

              location: capitalizeText(formData.get('partyLocation')),
              address: capitalizeText(formData.get('partyAddress')),
              time: formData.get('partyTime'),
              details: formData.get('partyDetails'),
            }
          }
        }));

        // ✅ Scroll suave al top
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        alert('❌ Error al guardar: ' + data.error);
      }
    } catch (error) {
      console.error('Error saving setup:', error);
      alert('❌ Error al guardar los datos');
    }
  };
  // const totalContributors = gifts.reduce((sum, gift) => {
  //   return sum + (gift.contributors?.length || 0);
  // }, 0);

  const formatPrice = (price) => {
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: couple.preferences?.currency || 'ARS',
      minimumFractionDigits: 0
    }).format(price);
  };
  // const formatDate = (dateString) => {
  //   return new Date(dateString).toLocaleDateString('es-AR', {
  //     year: 'numeric',
  //     month: 'long',
  //     day: 'numeric',
  //     hour: '2-digit',
  //     minute: '2-digit'
  //   });
  // };


  // Handler para exportar PDF
  // const handleExportPDF = () => {
  //   const doc = new jsPDF();

  //   // Header
  //   doc.setFontSize(20);
  //   doc.setTextColor(241, 90, 142);
  //   doc.text(`Regalos Recibidos`, 14, 20);

  //   doc.setFontSize(12);
  //   doc.setTextColor(0, 0, 0);
  //   doc.text(`${couple.brideName} & ${couple.groomName}`, 14, 28);
  //   doc.text(`Fecha del evento: ${new Date(couple.weddingDate).toLocaleDateString('es-AR')}`, 14, 34);

  //   doc.setFontSize(10);
  //   doc.setTextColor(100, 100, 100);
  //   doc.text(`Generado el ${new Date().toLocaleDateString('es-AR')} a las ${new Date().toLocaleTimeString('es-AR')}`, 14, 40);

  //   const allContributors = gifts
  //     .filter(g => g.contributors && g.contributors.length > 0)
  //     .flatMap(gift =>
  //       gift.contributors.map(contributor => ({
  //         guestName: contributor.name,
  //         giftName: gift.name,
  //         amount: contributor.amount,
  //         paymentMethod: contributor.paymentMethod || 'transferencia',
  //         date: contributor.date,
  //         receiptUrl: contributor.receiptUrl,
  //       }))
  //     )
  //     .sort((a, b) => new Date(b.date) - new Date(a.date));

  //   const totalAmount = allContributors.reduce((sum, c) => sum + c.amount, 0);

  //   // ✅ Helper para formatear dentro del PDF
  //   const formatPricePDF = (price) => {
  //     return new Intl.NumberFormat('es-AR', {
  //       style: 'currency',
  //       currency: couple?.preferences?.currency || 'ARS',
  //       minimumFractionDigits: 0
  //     }).format(price);
  //   };

  //   // Summary
  //   doc.setFontSize(12);
  //   doc.setTextColor(0, 0, 0);
  //   doc.text(`Total de regalos: ${allContributors.length}`, 14, 50);
  //   doc.text(`Total recibido: ${formatPricePDF(totalAmount)}`, 14, 56); // ✅ Usar formatPricePDF

  //   // Table
  //   const tableData = allContributors.map(c => [
  //     c.guestName,
  //     c.giftName,
  //     formatPricePDF(c.amount), // ✅ Usar formatPricePDF
  //     c.paymentMethod.replace('_', ' '),
  //     new Date(c.date).toLocaleDateString('es-AR'),
  //     c.receiptUrl ? '✓' : '-',
  //   ]);

  //   autoTable(doc, {
  //     startY: 65,
  //     head: [['Invitado', 'Regalo', 'Monto', 'Método', 'Fecha', 'Comprobante']],
  //     body: tableData,
  //     theme: 'striped',
  //     headStyles: {
  //       fillColor: [241, 90, 142],
  //       textColor: 255,
  //       fontStyle: 'bold',
  //     },
  //     styles: {
  //       fontSize: 9,
  //       cellPadding: 3,
  //     },
  //     columnStyles: {
  //       0: { cellWidth: 35 },
  //       1: { cellWidth: 45 },
  //       2: { cellWidth: 25 },
  //       3: { cellWidth: 30 },
  //       4: { cellWidth: 30 },
  //       5: { cellWidth: 15 },
  //     },
  //   });

  //   // Save PDF
  //   const filename = `regalos-${couple.id}-${new Date().toISOString().split('T')[0]}.pdf`;
  //   doc.save(filename);
  // };
  // ========== NUEVA VERSIÓN DE handleExportPDF ==========
  // Reemplazar la función completa (líneas ~830-915) con esta:

  const handleExportPDF = () => {
    const doc = new jsPDF();

    // Helper para formatear precios en PDF
    const formatPricePDF = (price) => {
      return new Intl.NumberFormat('es-AR', {
        style: 'currency',
        currency: couple?.preferences?.currency || 'ARS',
        minimumFractionDigits: 0
      }).format(price);
    };

    // ===== HEADER =====
    doc.setFontSize(20);
    doc.setTextColor(241, 90, 142);
    doc.text('Regalos Recibidos - Detalle Completo', 14, 20);

    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.text(`${couple.brideName} & ${couple.groomName}`, 14, 28);
    doc.text(`Fecha del evento: ${new Date(couple.weddingDate).toLocaleDateString('es-AR')}`, 14, 34);

    doc.setFontSize(10);
    doc.setTextColor(100, 100, 100);
    doc.text(`Generado el ${new Date().toLocaleDateString('es-AR')} a las ${new Date().toLocaleTimeString('es-AR')}`, 14, 40);

    // ===== CALCULAR TOTALES =====
    const receivedGifts = gifts.filter(g => (g.amountReceived || 0) > 0);
    const totalAmount = receivedGifts.reduce((sum, g) => sum + (g.amountReceived || 0), 0);
    const totalContributors = receivedGifts.reduce((sum, g) => sum + (g.contributors?.length || 0), 0);

    // ===== SUMMARY =====
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.text(`Regalos con aportes: ${receivedGifts.length}`, 14, 50);
    doc.text(`Total de aportes: ${totalContributors}`, 14, 56);
    doc.text(`Monto total recibido: ${formatPricePDF(totalAmount)}`, 14, 62);

    // ===== PREPARAR DATOS PARA LA TABLA =====
    const tableData = [];

    receivedGifts
      .sort((a, b) => {
        // Ordenar por fecha del último aporte
        const dateA = a.contributors?.[a.contributors.length - 1]?.date || 0;
        const dateB = b.contributors?.[b.contributors.length - 1]?.date || 0;
        return new Date(dateB) - new Date(dateA);
      })
      .forEach((gift, giftIndex) => {
        const progress = ((gift.amountReceived || 0) / gift.price) * 100;
        const isCompleted = progress >= 100;
        const status = isCompleted ? '✓ Completado' : `${Math.round(progress)}%`;

        // ===== HEADER DEL REGALO (fila con fondo gris) =====
        tableData.push([
          {
            content: `${gift.name.toUpperCase()} (${formatPricePDF(gift.price)})`,
            colSpan: 6,
            styles: {
              fillColor: [240, 240, 240],
              fontStyle: 'bold',
              fontSize: 10,
              textColor: [0, 0, 0]
            }
          }
        ]);

        // ===== APORTES DEL REGALO =====
        if (gift.contributors && gift.contributors.length > 0) {
          gift.contributors.forEach((contributor, idx) => {
            tableData.push([
              contributor.name || 'Anónimo',
              contributor.email || '-',
              contributor.phone || '-',
              formatPricePDF(contributor.amount),
              new Date(contributor.date).toLocaleDateString('es-AR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
              }),
              contributor.receiptUrl ? 'Si' : 'No'
            ]);
          });
        }

        // ===== SUB-TOTAL DEL REGALO =====
        tableData.push([
          {
            content: `Sub-total: ${formatPricePDF(gift.amountReceived || 0)} / ${formatPricePDF(gift.price)} (${status})`,
            colSpan: 6,
            styles: {
              fillColor: isCompleted ? [220, 252, 231] : [254, 243, 199], // verde claro si completado, amarillo si no
              fontStyle: 'bold',
              fontSize: 9,
              textColor: [0, 0, 0]
            }
          }
        ]);

        // ===== LÍNEA SEPARADORA (solo si no es el último regalo) =====
        if (giftIndex < receivedGifts.length - 1) {
          tableData.push([
            { content: '', colSpan: 6, styles: { minCellHeight: 3, fillColor: [255, 255, 255] } }
          ]);
        }
      });

    // ===== GENERAR TABLA =====
    autoTable(doc, {
      startY: 72,
      head: [['Nombre', 'Email', 'Teléfono', 'Monto', 'Fecha', 'Comp.']],
      body: tableData,
      theme: 'grid',
      headStyles: {
        fillColor: [241, 90, 142],
        textColor: 255,
        fontStyle: 'bold',
        fontSize: 9
      },
      styles: {
        fontSize: 8,
        cellPadding: 2,
        lineColor: [220, 220, 220],
        lineWidth: 0.1
      },
      columnStyles: {
        0: { cellWidth: 35 },  // Nombre
        1: { cellWidth: 45 },  // Email
        2: { cellWidth: 25 },  // Teléfono
        3: { cellWidth: 25, halign: 'right' },  // Monto
        4: { cellWidth: 25 },  // Fecha
        5: { cellWidth: 15, halign: 'center' }   // Comprobante
      },
      didParseCell: function (data) {
        // Asegurar que las filas de header de regalo y sub-total ocupen todo el ancho
        if (data.cell.raw && data.cell.raw.colSpan) {
          data.cell.styles.halign = 'left';
        }
      }
    });

    // ===== FOOTER =====
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setTextColor(150, 150, 150);
      doc.text(
        `Página ${i} de ${pageCount}`,
        doc.internal.pageSize.width / 2,
        doc.internal.pageSize.height - 10,
        { align: 'center' }
      );
    }

    // ===== GUARDAR PDF =====
    const filename = `regalos-detalle-${couple.id}-${new Date().toISOString().split('T')[0]}.pdf`;
    doc.save(filename);
  };
  // Handler para guardar Banking
  const handleSaveBanking = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    // ✅ Validar CVU de Mercado Pago
    const mpCVU = formData.get('mercadoPagoCVU');
    if (mpCVU && (mpCVU.length !== 22 || !/^\d{22}$/.test(mpCVU))) {
      alert('❌ El CVU de Mercado Pago debe tener exactamente 22 dígitos numéricos');
      return;
    }

    // ✅ Validar alias de Mercado Pago
    const mpAlias = formData.get('mercadoPagoAlias');
    if (mpAlias && !/^[a-z0-9.]+$/.test(mpAlias)) {
      alert('❌ El alias de Mercado Pago solo puede contener minúsculas, números y puntos');
      return;
    }

    // ✅ Validar CBU ARS
    const arsCbu = formData.get('arsCbu');
    if (arsCbu && (arsCbu.length !== 22 || !/^\d{22}$/.test(arsCbu))) {
      alert('❌ El CBU en ARS debe tener exactamente 22 dígitos numéricos');
      return;
    }

    // ✅ Validar CBU USD
    const usdCbu = formData.get('usdCbu');
    if (usdCbu && (usdCbu.length !== 22 || !/^\d{22}$/.test(usdCbu))) {
      alert('❌ El CBU en USD debe tener exactamente 22 dígitos numéricos');
      return;
    }

    // ✅ Validar email de PayPal
    const paypalEmail = formData.get('usdPaypalEmail');
    if (paypalEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(paypalEmail)) {
      alert('❌ El email de PayPal no es válido');
      return;
    }


    try {
      const token = localStorage.getItem('token');

      const response = await fetch(API_ENDPOINTS.giftUpdateBanking, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          arsAlias: formData.get('arsAlias'),
          arsCbu: formData.get('arsCbu'),
          arsAccountHolder: formData.get('arsAccountHolder'),
          arsBank: formData.get('arsBank'),
          usdAlias: formData.get('usdAlias'),
          usdCbu: formData.get('usdCbu'),
          usdAccountHolder: formData.get('usdAccountHolder'),
          usdBank: formData.get('usdBank'),
          usdPaypalEmail: formData.get('usdPaypalEmail'),
          preferredCurrency: formData.get('preferredCurrency'),
          mercadoPagoCVU: formData.get('mercadoPagoCVU'),
          mercadoPagoAlias: formData.get('mercadoPagoAlias'),
          // ✅ Agregar estos
          paymentMethods: {
            transferARS: formData.get('enableTransferARS') === 'on',
            transferUSD: formData.get('enableTransferUSD') === 'on',
            mercadoPago: formData.get('enableMercadoPago') === 'on',
            paypal: formData.get('enablePayPal') === 'on',
            efectivo: formData.get('enableEfectivo') === 'on',
          }
        })
      });

      const data = await response.json();

      if (data.success) {
        alert('✅ Datos bancarios guardados exitosamente');

        // Actualizar estados locales
        setBankingData({
          arsComplete: !!(formData.get('arsCbu')),
          usdComplete: !!(formData.get('usdCbu')),
          mpComplete: !!(formData.get('mercadoPagoCVU') || formData.get('mercadoPagoAlias')),

        });

        // Actualizar el objeto couple con los nuevos datos bancarios
        setCouple(prev => ({
          ...prev,
          accountInfoARS: {
            alias: formData.get('arsAlias'),
            cbu: formData.get('arsCbu'),
            accountHolder: formData.get('arsAccountHolder'),
            bank: formData.get('arsBank'),
          },
          accountInfoUSD: {
            alias: formData.get('usdAlias'),
            cbu: formData.get('usdCbu'),
            accountHolder: formData.get('usdAccountHolder'),
            bank: formData.get('usdBank'),
            paypalEmail: formData.get('usdPaypalEmail'),
          },
          mercadoPago: {
            cvu: formData.get('mercadoPagoCVU'),
            alias: formData.get('mercadoPagoAlias'),
          },
          preferences: {
            ...prev.preferences,
            currency: formData.get('preferredCurrency'),
          },
          paymentMethods: {
            transferARS: formData.get('enableTransferARS') === 'on',
            transferUSD: formData.get('enableTransferUSD') === 'on',
            mercadoPago: formData.get('enableMercadoPago') === 'on',
            paypal: formData.get('enablePayPal') === 'on',
            efectivo: formData.get('enableEfectivo') === 'on',
          }
        }));

        // ✅ Scroll suave al top
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        alert('❌ Error al guardar: ' + data.error);
      }
    } catch (error) {
      console.error('Error saving banking:', error);
      alert('❌ Error al guardar los datos bancarios');
    }
  };

  // const totalReceived = mockReceivedGifts.reduce((sum, gift) => sum + gift.amount, 0);
  // const totalGifts = mockGifts.length;
  // const reservedGifts = mockGifts.filter(g => g.reserved).length;

  // Actualizar cálculos con datos reales
  // const totalReceived = receivedGifts.reduce((sum, gift) => sum + (gift.amount || 0), 0);
  // const totalGifts = gifts.length;
  // const reservedGifts = gifts.filter(g => g.reserved).length;
  // ✅ DESPUÉS: Calcular desde gifts.contributors
  const totalReceived = gifts.reduce((sum, gift) => {
    return sum + (gift.amountReceived || 0);
  }, 0);

  const totalGifts = gifts.length;
const reservedGifts = gifts.filter(g => (g.amountReceived || 0) > 0).length;

  // ✅ DEBUG: Agregar antes del return, después de calcular totalReceived
  // console.log('🔍 DEBUG Overview:');
  // console.log('Total desde gifts.amountReceived:', totalReceived);

  // const totalFromContributors = gifts.reduce((sum, gift) => {
  //   const giftTotal = gift.contributors?.reduce((s, c) => s + c.amount, 0) || 0;
  //   return sum + giftTotal;
  // }, 0);
  // console.log('Total desde contributors:', totalFromContributors);

  // gifts.forEach(gift => {
  //   if (gift.contributors && gift.contributors.length > 0) {
  //     const contributorsSum = gift.contributors.reduce((s, c) => s + c.amount, 0);
  //     console.log(`${gift.name}: amountReceived=${gift.amountReceived}, contributorsSum=${contributorsSum}`);
  //   }
  // });

  // ✅ Bonus: Total de aportes/contributors



  // Antes del return, agregar:
  // 3. Agregar función para subir imagen (usando signed URLs):
  const handleProfileImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validar tamaño (máximo 5MB)
    if (file.size > 5 * 1024 * 1024) {
      alert('❌ La imagen debe ser menor a 5MB');
      return;
    }

    // Validar tipo
    if (!file.type.startsWith('image/')) {
      alert('❌ Solo se permiten imágenes');
      return;
    }

    try {
      setUploadingProfileImage(true);

      const token = localStorage.getItem('token');

      // Paso 1: Obtener URL pre-firmada
      const urlResponse = await fetch(API_ENDPOINTS.giftUploadProfileImage, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          filename: file.name,
          contentType: file.type,
          coupleId: couple.id
        })
      });

      const urlData = await urlResponse.json();

      if (!urlData.success) {
        alert('❌ Error: ' + urlData.error);
        return;
      }

      // Paso 2: Subir imagen a Cloud Storage usando la URL pre-firmada
      const uploadResponse = await fetch(urlData.uploadUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': file.type
        },
        body: file
      });

      if (!uploadResponse.ok) {
        throw new Error('Error al subir la imagen');
      }

      // Paso 3: Actualizar estado local con la URL pública
      setCouple({ ...couple, profileImage: urlData.publicUrl });

      // Paso 4: Actualizar Firestore inmediatamente (en lugar de esperar 60s)
      await fetch(API_ENDPOINTS.giftUpdateCouple, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          coupleId: couple.id,
          updates: {
            profileImage: urlData.publicUrl
          }
        })
      });

      alert('✅ Foto subida exitosamente');
    } catch (error) {
      console.error('Error uploading image:', error);
      alert('❌ Error al subir la foto');
    } finally {
      setUploadingProfileImage(false);
    }
  };

  const handleDeleteProfileImage = async () => {
    if (!window.confirm('¿Seguro que querés eliminar la foto de perfil?')) {
      return;
    }

    try {
      const token = localStorage.getItem('token');

      const response = await fetch(API_ENDPOINTS.giftUpdateCouple, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          coupleId: couple.id,
          updates: {
            profileImage: null // ← Eliminar foto
          }
        })
      });

      const data = await response.json();

      if (data.success) {
        setCouple({ ...couple, profileImage: null });
        alert('✅ Foto eliminada exitosamente');
      } else {
        alert('❌ Error al eliminar la foto');
      }
    } catch (error) {
      console.error('Error deleting profile image:', error);
      alert('❌ Error al eliminar la foto');
    }
  };

  const handleCopyLink = async () => {
  const url = `${window.location.origin}/lista/${couple.id}`;

  try {
    await navigator.clipboard.writeText(url);
    setToast({
      type: "success",
      title: "Enlace copiado",
      // message: "Ya podés pegarlo en WhatsApp o donde quieras.",
    });
  } catch (e) {
    // fallback viejo
    const el = document.createElement("textarea");
    el.value = url;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);

    setToast({
      type: "success",
      title: "Link copiado",
      // message: "Ya podés pegarlo en WhatsApp o donde quieras.",
    });
  }
};

  return (
    <div className="min-h-screen bg-neutral-50">
      {/* Header */}
      <CoupleDashboardHeader
        couple={couple}
        onShare={() => setShowShareModal(true)}
        onLogout={handleLogout}
      />
      {showBackToTop && (
        <button
          type="button"
          onClick={() => receivedTopRef.current?.scrollIntoView({ behavior: "smooth" })}
          className="fixed bottom-6 right-4 sm:right-6 z-40
               rounded-full shadow-lg border border-neutral-200
               bg-white hover:bg-neutral-50
               w-12 h-12 flex items-center justify-center
               text-neutral-700"
          aria-label="Volver arriba"
        >
          ↑
        </button>
      )}


      <DashboardTabs activeTab={activeTab} onTabChange={setActiveTab} />


      {/* Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">


        {/* Setup Tab */}
        {activeTab === 'setup' && (
          <form onSubmit={handleSaveSetup} onChange={handleSetupFormChange} className="space-y-6 animate-fade-in max-w-4xl mx-auto">
            {/* Progress Header */}
            {/* <div className="bg-gradient-to-r from-accent-500 to-primary-500 rounded-2xl p-8 text-white"> */}
            <div className="bg-gradient-to-r from-accent-500 to-primary-500 rounded-2xl p-5 sm:p-8 text-white">

              <div className="flex items-center justify-between mb-4">
                <div>
                  {/* <h2 className="text-3xl font-display font-bold mb-2"> */}
                  <h2 className="text-2xl sm:text-3xl font-display font-bold mb-2">
                    Datos del Evento
                  </h2>
                  <p className="text-white/90">
                    Completá los detalles de tu ceremonia y fiesta
                  </p>
                </div>
                <div className="text-center">
                  {/* <div className="text-5xl font-bold">{calculateSetupProgress()}%</div> */}
                  <div className="text-3xl sm:text-5xl font-bold">{calculateSetupProgress()}%</div>
                  <p className="text-sm text-white/80">Completado</p>
                </div>
              </div>

              <div className="w-full bg-white/20 rounded-full h-3">
                <div
                  className="bg-white h-3 rounded-full transition-all duration-500"
                  style={{ width: `${calculateSetupProgress()}%` }}
                />
              </div>
            </div>

            {/* Status Alert */}
            {!isSetupComplete() && (
              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-lg">
                <div className="flex items-start">
                  <span className="text-3xl mr-4">⚠️</span>
                  <div>
                    <h3 className="text-lg font-semibold text-yellow-800 mb-2">
                      Faltan datos del evento
                    </h3>
                    <p className="text-yellow-700">
                      Completá toda la información para que tus invitados sepan dónde y cuándo será el evento.
                    </p>
                  </div>
                </div>
              </div>
            )}

            {isSetupComplete() && (
              <div className="bg-green-50 border-l-4 border-green-400 p-6 rounded-lg">
                <div className="flex items-start">
                  <span className="text-3xl mr-4">✅</span>
                  <div>
                    <h3 className="text-lg font-semibold text-green-800 mb-2">
                      ¡Datos del evento completos!
                    </h3>
                    <p className="text-green-700">
                      Toda la información está lista. No olvides completar también tus datos bancarios.
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* Ceremony Section */}
            <div className={`card p-6 space-y-4 ${!setupData.ceremonyComplete ? 'border-2 border-red-300' : ''}`}>
              <div className="flex items-center justify-between">
                <h3 className="text-xl font-display font-semibold text-neutral-900 flex items-center gap-2">
                  <span>⛪</span> Ceremonia
                </h3>
                {setupData.ceremonyComplete ? (
                  <span className="text-green-600 text-sm font-semibold">✓ Completado</span>
                ) : (
                  <span className="text-red-600 text-sm font-semibold"></span>
                )}
              </div>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-neutral-700 mb-2">
                    Fecha de la Ceremonia
                  </label>
                  <input
                    type="date"
                    name="ceremonyDate"
                    defaultValue={couple.eventDetails?.ceremony?.date || couple.weddingDate || ''}
                    min={new Date().toISOString().split('T')[0]} // ✅ No permitir fechas pasadas
                    className="input-field"
                  />
                  <p className="text-xs text-neutral-500 mt-1">
                    La fecha debe ser hoy o posterior
                  </p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-neutral-700 mb-2">
                    Lugar de la Ceremonia
                  </label>
                  <input
                    type="text"
                    name="ceremonyLocation"
                    defaultValue={couple.eventDetails?.ceremony?.location || ''}
                    placeholder="Iglesia Nuestra Señora del Carmen"
                    className="input-field"
                    maxLength="100" // ✅ Límite de caracteres
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-neutral-700 mb-2">
                    Dirección
                  </label>
                  <input
                    type="text"
                    name="ceremonyAddress"
                    defaultValue={couple.eventDetails?.ceremony?.address || ''}
                    placeholder="Av. Córdoba 1250, CABA"
                    className="input-field"
                    maxLength="200" // ✅ Límite de caracteres
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-neutral-700 mb-2">
                    Hora
                  </label>
                  <input
                    type="time"
                    name="ceremonyTime"
                    defaultValue={couple.eventDetails?.ceremony?.time?.replace(' hs', '') || ''}
                    className="input-field"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-neutral-700 mb-2">
                    Detalles adicionales
                  </label>
                  <textarea
                    rows="2"
                    name="ceremonyDetails"
                    defaultValue={couple.eventDetails?.ceremony?.details || ''}
                    placeholder="Por ejemplo: Por favor llegar 15 minutos antes"
                    className="input-field resize-none"
                    maxLength="500" // ✅ Límite de caracteres
                  />
                  <p className="text-xs text-neutral-400 text-right">
                    {couple.eventDetails?.ceremony?.details?.length || 0}/500
                  </p>
                </div>
              </div>
            </div>

            {/* Party Section */}
            <div className={`card p-6 space-y-4 ${!setupData.partyComplete ? 'border-2 border-red-300' : ''}`}>
              <div className="flex items-center justify-between">
                <h3 className="text-xl font-display font-semibold text-neutral-900 flex items-center gap-2">
                  <span>🎉</span> Fiesta
                </h3>
                {setupData.partyComplete ? (
                  <span className="text-green-600 text-sm font-semibold">✓ Completado</span>
                ) : (
                  <span className="text-red-600 text-sm font-semibold"></span>
                )}
              </div>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-neutral-700 mb-2">
                    Fecha de la Fiesta
                  </label>
                  <input
                    type="date"
                    name="partyDate"
                    // defaultValue={couple.weddingDate || ''}
                    defaultValue={couple.eventDetails?.party?.date || couple.weddingDate || ''}  // ✅ CORRECTO
                    min={new Date().toISOString().split('T')[0]} // ✅ No permitir fechas pasadas
                    className="input-field"
                  />
                  <p className="text-xs text-neutral-500 mt-1">
                    Puede ser el mismo día de la ceremonia o diferente
                  </p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-neutral-700 mb-2">
                    Lugar de la Fiesta
                  </label>
                  <input
                    type="text"
                    name="partyLocation"
                    defaultValue={couple.eventDetails?.party?.location || ''}
                    placeholder="Salón Las Magnolias"
                    className="input-field"
                    maxLength="100" // ✅ Límite de caracteres
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-neutral-700 mb-2">
                    Dirección
                  </label>
                  <input
                    type="text"
                    name="partyAddress"
                    defaultValue={couple.eventDetails?.party?.address || ''}
                    placeholder="Camino del Buen Ayre km 5.5, Vicente López"
                    className="input-field"
                    maxLength="200" // ✅ Límite de caracteres
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-neutral-700 mb-2">
                    Hora
                  </label>
                  <input
                    type="time"
                    name="partyTime"
                    defaultValue={couple.eventDetails?.party?.time?.replace(' hs', '') || ''}
                    className="input-field"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-neutral-700 mb-2">
                    Detalles adicionales
                  </label>
                  <textarea
                    rows="2"
                    name="partyDetails"
                    defaultValue={couple.eventDetails?.party?.details || ''}
                    placeholder="Por ejemplo: Dress code: Formal. Estacionamiento disponible."
                    className="input-field resize-none"
                    maxLength="500" // ✅ Límite de caracteres
                  />
                  <p className="text-xs text-neutral-400 text-right">
                    {couple.eventDetails?.party?.details?.length || 0}/500
                  </p>
                </div>
              </div>
            </div>

            <div className="card p-6">
              <h3 className="text-xl font-display font-semibold text-neutral-900 mb-4">
                🖼️ Foto de perfil
              </h3>
              <p className="text-sm text-neutral-600 mb-4">
                Subí una foto de ustedes para personalizar su lista de regalos (opcional)
              </p>

              <div className="space-y-4">
                {/* Vista previa de la foto actual */}
                {couple.profileImage && (
                  <div className="flex items-center justify-between gap-4 p-4 bg-neutral-50 rounded-lg border border-neutral-200">
                    <div className="flex items-center gap-4">
                      <img
                        src={couple.profileImage}
                        alt="Foto de perfil"
                        className="w-24 h-24 rounded-full object-cover border-2 border-neutral-200 shadow-sm"
                      />
                      <div>
                        <p className="text-sm font-medium text-neutral-900">Foto actual</p>
                        <p className="text-xs text-neutral-500">
                          Esta foto aparecerá en tu lista pública
                        </p>
                      </div>
                    </div>

                    {/* Botón eliminar */}
                    <button
                      type="button"  // ✅ Agregar esto

                      onClick={handleDeleteProfileImage}
                      className="px-3 py-2 text-sm text-red-600 hover:text-red-700 hover:bg-red-50 rounded-lg transition-colors font-medium"
                    >
                      🗑️ Eliminar
                    </button>
                  </div>
                )}

                {/* Input para subir nueva foto */}
                <div>
                  <label className="block">
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleProfileImageUpload}
                      disabled={uploadingProfileImage}
                      className="hidden"
                      id="profile-image-upload"
                    />
                    <label
                      htmlFor="profile-image-upload"
                      className={`cursor-pointer inline-flex items-center gap-2 px-4 py-2 bg-accent-500 text-white rounded-lg hover:bg-accent-600 transition-colors ${uploadingProfileImage ? 'opacity-50 cursor-not-allowed' : ''
                        }`}
                    >
                      {uploadingProfileImage ? (
                        <>
                          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                          Subiendo...
                        </>
                      ) : (
                        <>
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                          </svg>
                          {couple.profileImage ? 'Cambiar foto' : 'Subir foto'}
                        </>
                      )}
                    </label>
                  </label>
                  <p className="text-xs text-neutral-500 mt-2">
                    Formatos: JPG, PNG, GIF, WEBP. Tamaño máximo: 5MB
                  </p>
                </div>
              </div>
            </div>

            {/* Save Button */}
            <div className="sticky bottom-4 bg-white rounded-xl shadow-xl p-3 sm:p-4 border border-neutral-200">
              <div className="flex flex-col sm:flex-row gap-2 sm:gap-4">
                <button
                  type="submit"
                  disabled={!setupFormDirty}  // ✅ Agregar esto

                  className={`w-full sm:flex-1 btn-primary text-base py-3 sm:py-3 ${!setupFormDirty ? 'opacity-50 cursor-not-allowed' : ''
                    }`}                >
                  Guardar cambios
                </button>

                {isSetupComplete() && (
                  <button
                    type="button"
                    onClick={() => setActiveTab("banking")}
                    className="w-full sm:w-auto btn-secondary px-4 sm:px-6 py-3 sm:py-3 text-base"
                  >
                    Completar cobros →
                  </button>
                )}
              </div>
            </div>
          </form>
        )}

        {/* Overview Tab */}


        {activeTab === 'overview' && (
          <div className="space-y-4 sm:space-y-6 animate-fade-in">
            {/* Stats Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3 sm:gap-6">
              <div className="card p-4 sm:p-6">
                <div className="flex items-center justify-between mb-2 sm:mb-4">
                  <h3 className="text-neutral-600 font-medium text-sm sm:text-base">
                    Total Recibido
                  </h3>
                  <span className="text-xl sm:text-3xl">Total</span>
                </div>
                <p className="text-2xl sm:text-3xl font-display font-bold text-accent-600">
                  {formatPrice(totalReceived)}
                </p>
              </div>

              <div className="card p-4 sm:p-6">
                <div className="flex items-center justify-between mb-2 sm:mb-4">
                  <h3 className="text-neutral-600 font-medium text-sm sm:text-base">
                    Regalos Recibidos
                  </h3>
                  <span className="text-xl sm:text-3xl">🎁</span>
                </div>
                <p className="text-2xl sm:text-3xl font-display font-bold text-accent-600">
                  {reservedGifts} / {totalGifts}
                </p>
              </div>

              <div className="card p-4 sm:p-6">
                <div className="flex items-center justify-between mb-2 sm:mb-4">
                  <h3 className="text-neutral-600 font-medium text-sm sm:text-base">
                    Días para el evento
                  </h3>
                  <span className="text-xl sm:text-3xl">📅</span>
                </div>
                <p className="text-2xl sm:text-3xl font-display font-bold text-neutral-900">
                  {Math.ceil(
                    (new Date(couple.eventDetails?.party?.date || couple.eventDetails?.ceremony?.date || couple.weddingDate) - new Date()) / (1000 * 60 * 60 * 24)
                  )}
                </p>
                <p className="text-xs text-neutral-500 mt-1">
  {(() => {
    const eventDate = couple.eventDetails?.party?.date || couple.eventDetails?.ceremony?.date || couple.weddingDate;
    const [year, month, day] = eventDate.split('-').map(Number);
    return new Date(year, month - 1, day).toLocaleDateString('es-AR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  })()}
</p>
              </div>
            </div>

            {/* Recent Gifts */}
            <div className="card">
              <div className="p-6 border-b border-neutral-200">
                <h2 className="text-xl font-display font-bold text-neutral-900">
                  Últimos Regalos Recibidos
                </h2>
              </div>

              {gifts.filter(g => (g.amountReceived || 0) > 0).length === 0 ? (
                <div className="p-12 text-center">
                  <div className="text-6xl mb-4">🎁</div>
                  <p className="text-xl text-neutral-600">Todavía no recibiste regalos</p>
                </div>
              ) : (
                <div className="divide-y divide-neutral-200">
                  {gifts
                    .filter(g => (g.amountReceived || 0) > 0)
                    .sort((a, b) => {
                      // ✅ Ordenar por fecha del último contributor
                      const dateA = a.contributors?.[a.contributors.length - 1]?.date || 0;
                      const dateB = b.contributors?.[b.contributors.length - 1]?.date || 0;
                      return new Date(dateB) - new Date(dateA);
                    })
                    .slice(0, 5)
                    .map(gift => {
                      const lastContributor = gift.contributors?.[gift.contributors.length - 1];
                      const progress = ((gift.amountReceived || 0) / gift.price) * 100;

                      return (
                        <div key={gift.id} className="p-6 hover:bg-neutral-50 transition-colors">
                          <div className="flex justify-between items-start mb-2">
                            <div>
                              <p className="font-semibold text-neutral-900">{gift.name}</p>
                              <p className="text-sm text-neutral-600">
                                Último aporte: {lastContributor?.name || 'Anónimo'}
                              </p>
                            </div>
                            <div className="text-right">
                              <p className="text-lg font-bold text-accent-600">
                                {formatPrice(lastContributor?.amount || 0)}
                              </p>
                              {progress < 100 && (
                                <p className="text-xs text-amber-600">
                                  {Math.round(progress)}% completado
                                </p>
                              )}
                              {progress >= 100 && (
                                <p className="text-xs text-green-600">
                                  ✓ Completado
                                </p>
                              )}
                            </div>
                          </div>

                          {/* Mostrar mensaje del último contributor si existe */}
                          {(() => {
                            const receivedEntry = receivedGifts.find(
                              r => r.giftId === gift.id && r.guestEmail === lastContributor?.email
                            );
                            return receivedEntry?.message ? (
                              <p className="text-sm text-neutral-600 italic mt-2 bg-neutral-50 p-3 rounded-lg">
                                "{receivedEntry.message}"
                              </p>
                            ) : null;
                          })()}

                          <p className="text-xs text-neutral-400 mt-2">
                            {new Date(lastContributor?.date).toLocaleDateString('es-AR', {
                              day: 'numeric',
                              month: 'long',
                              year: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit'
                            })}
                          </p>
                        </div>
                      );
                    })}
                </div>
              )}
            </div>

            {/* Share Link */}
        <div className="bg-gradient-to-r from-accent-500 to-accent-600 rounded-2xl p-4 sm:p-8 text-white">
  <h3 className="text-xl sm:text-2xl font-display font-bold mb-2 sm:mb-4">
    Compartí tu lista
  </h3>

  <p className="mb-3 sm:mb-4 text-accent-50 text-sm sm:text-base">
    Copiá este enlace y compartilo con tus invitados:
  </p>

  <div className="flex flex-col sm:flex-row gap-2 sm:gap-3">
    <input
      type="text"
      readOnly
      value={`${window.location.origin}/lista/${couple.id}`}
      className="w-full sm:flex-1 px-3 sm:px-4 py-2 sm:py-3
                 rounded-lg text-neutral-900 font-mono text-xs sm:text-sm"
    />

    <button
      type="button"
      onClick={handleCopyLink}
      className="bg-white text-accent-600 px-4 sm:px-6 py-2 sm:py-3
                 rounded-lg font-semibold text-sm sm:text-base
                 hover:bg-accent-50 transition-colors"
    >
      Copiar
    </button>
  </div>

  <button
    type="button"
    onClick={() => setShowShareModal(true)}
    className="mt-3 w-full bg-neutral-900/15 hover:bg-neutral-900/25 text-white
               px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg font-semibold
               text-sm sm:text-base transition-colors"
  >
    Compartir por WhatsApp (con mensaje)
  </button>
</div>
          </div>
        )}



        {/* Gifts Tab */}
        {activeTab === "gifts" && (
          <div className="space-y-4 sm:space-y-6 animate-fade-in">
            {/* Header */}
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3">
              <h2 className="text-xl sm:text-2xl font-display font-bold text-neutral-900">
                Mi Lista de Regalos
              </h2>

              {/* Actions */}
              <div className="flex flex-col sm:flex-row gap-2 sm:gap-3">
                <button
                  onClick={() => setShowOnboarding(true)}
                  className="btn-secondary py-3"
                >
                  🎁 Agregar desde catálogo
                </button>

                <button
                  onClick={handleCreateGift}
                  className="btn-primary py-3"
                >
                  + Agregar Manual
                </button>
              </div>
            </div>

            {loadingGifts ? (
              <div className="card p-12 text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent-500 mx-auto"></div>
                <p className="text-neutral-600 mt-4">Cargando regalos...</p>
              </div>
            ) : gifts.length === 0 ? (
              <div className="card p-12 text-center">
                <div className="text-6xl mb-4">🎁</div>
                <p className="text-xl text-neutral-600 mb-4">Todavía no agregaste regalos a tu lista</p>
                <p className="text-neutral-500 mb-6">
                  Podés agregar regalos manualmente o elegir desde nuestro catálogo
                </p>

                {/* ✅ Botones en el estado vacío
                <div className="flex gap-3 justify-center">
                  <button
                    onClick={() => setShowOnboarding(true)}
                    className="btn-secondary"
                  >
                    🎁 Explorar Catálogo
                  </button>
                  <button
                    onClick={handleCreateGift}
                    className="btn-primary"
                  >
                    + Agregar Manual
                  </button>
                </div> */}
              </div>
            ) : (
              <>
                {/* Category Breakdown */}
                {/* Agregá esto temporalmente ANTES del grid de categorías para ver qué pasa */}
                {/* <div className="bg-yellow-50 p-4 rounded mb-4">
                  <p className="font-mono text-xs">DEBUG:</p>
                  <p className="font-mono text-xs">Total gifts: {gifts.length}</p>
                  <p className="font-mono text-xs">Categories in gifts: {[...new Set(gifts.map(g => g.category))].join(', ')}</p>
                  <p className="font-mono text-xs">Category slugs: {giftCategories.map(c => c.slug).join(', ')}</p>
                </div> */}
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
                  {giftCategories
                    .filter(cat => gifts.some(g => g.category === cat.slug))
                    .map(cat => {
                      const categoryGifts = gifts.filter(g => g.category === cat.slug);
                      const categoryReserved = categoryGifts.filter(g => g.reserved).length;
                      const categoryAvailable = categoryGifts.length - categoryReserved;
                      const IconComponent = cat.Icon;



                      return (

                        <div
                          key={cat.id}
                          onClick={() =>
                            setSelectedCategory(prev => (prev === cat.slug ? null : cat.slug))
                          } className={`card p-4 text-center hover:shadow-lg transition-all cursor-pointer group
    ${selectedCategory === cat.slug ? "ring-2 ring-accent-500" : ""}`}
                        // className="card p-4 text-center hover:shadow-lg transition-all cursor-pointer group"
                        >
                          <div className="flex justify-center mb-3">
                            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-accent-100 to-accent-200 flex items-center justify-center group-hover:from-accent-200 group-hover:to-accent-300 transition-all">
                              <IconComponent className="w-7 h-7 text-accent-600" strokeWidth={1.5} />
                            </div>
                          </div>
                          <p className="text-sm font-semibold text-neutral-800 mb-1">{cat.name}</p>
                          <p className="text-xs text-neutral-500">
                            {categoryAvailable} disponible{categoryAvailable !== 1 ? 's' : ''}
                          </p>
                        </div>
                      );
                    })}
                </div>
                <div className="flex items-center justify-between">
                  <p className="text-sm text-neutral-600">
                    Mostrando <strong>{visibleGifts.length}</strong> regalo{visibleGifts.length !== 1 ? "s" : ""}
                    {selectedCategory && (
                      <>
                        {" "}en <strong>{giftCategories.find(c => c.slug === selectedCategory)?.name || selectedCategory}</strong>
                      </>
                    )}
                  </p>

                  {selectedCategory && (
                    <button
                      onClick={() => setSelectedCategory(null)}
                      className="text-sm text-neutral-600 hover:text-neutral-900"
                    >
                      Limpiar filtro
                    </button>
                  )}
                </div>

                {/* Gifts List */}
                {/* Bulk actions row */}
                <div className="flex items-center justify-between gap-3">
                  <div className="flex items-center gap-3">
                    <button
                      type="button"
                      onClick={() => setSelectionMode((v) => !v)}
                      className="text-sm font-semibold text-neutral-700 hover:text-neutral-900"
                    >
                      {selectionMode ? 'Cancelar' : 'Seleccionar'}
                    </button>

                    {selectionMode && (
                      <span className="text-sm text-neutral-600">
                        {selectedCount} seleccionado{selectedCount === 1 ? '' : 's'}
                      </span>
                    )}
                  </div>

                  {selectionMode && selectedCount > 0 && (
                    <div className="flex items-center gap-2">
                      <button
                        type="button"
                        onClick={clearSelection}
                        className="text-sm text-neutral-600 hover:text-neutral-900"
                      >
                        Limpiar
                      </button>
                      <button
                        type="button"
                        onClick={handleBulkDelete}
                        className="px-3 py-2 rounded-lg text-sm font-semibold
                   bg-red-600 text-white hover:bg-red-700 transition-colors"
                      >
                        Eliminar ({selectedCount})
                      </button>
                    </div>
                  )}
                </div>

                <div className="card overflow-hidden">
                  <div className="overflow-x-auto">
                    <table className="w-full">
                      <thead className="bg-neutral-50 border-b border-neutral-200">
                        <tr>
                          {selectionMode && (
                            <th className="px-4 py-3 w-10">
                              <input
                                type="checkbox"
                                checked={allVisibleSelected}
                                onChange={toggleSelectAllVisible}
                                className="h-4 w-4 rounded border-neutral-300"
                                aria-label="Seleccionar todos"
                              />
                            </th>
                          )}

                          <th className="px-6 py-3 text-left">
                            <button
                              type="button"
                              onClick={() => toggleGiftSort('name')}
                              className="inline-flex items-center gap-2 text-xs font-medium text-neutral-500 uppercase tracking-wider hover:text-neutral-700"
                            >
                              Regalo <span className="text-neutral-400">{sortIcon('name')}</span>
                            </button>
                          </th>

                          <th className="px-6 py-3 text-left">
                            <button
                              type="button"
                              onClick={() => toggleGiftSort('category')}
                              className="inline-flex items-center gap-2 text-xs font-medium text-neutral-500 uppercase tracking-wider hover:text-neutral-700"
                            >
                              Categoría <span className="text-neutral-400">{sortIcon('category')}</span>
                            </button>
                          </th>

                          <th className="px-6 py-3 text-left">
                            <button
                              type="button"
                              onClick={() => toggleGiftSort('price')}
                              className="inline-flex items-center gap-2 text-xs font-medium text-neutral-500 uppercase tracking-wider hover:text-neutral-700"
                            >
                              Precio <span className="text-neutral-400">{sortIcon('price')}</span>
                            </button>
                          </th>

                          <th className="px-6 py-3 text-left">
                            <button
                              type="button"
                              onClick={() => toggleGiftSort('status')}
                              className="inline-flex items-center gap-2 text-xs font-medium text-neutral-500 uppercase tracking-wider hover:text-neutral-700"
                            >
                              Estado <span className="text-neutral-400">{sortIcon('status')}</span>
                            </button>
                          </th>

                          <th className="px-6 py-3 text-right text-xs font-medium text-neutral-500 uppercase tracking-wider">
                            Acciones
                          </th>
                        </tr>
                      </thead>

                      <tbody className="bg-white divide-y divide-neutral-200">
                        {sortedVisibleGifts.map((gift) => (
                          <tr
                            key={gift.id}
                            className={`hover:bg-neutral-50 ${!gift.active ? 'opacity-50' : ''}`}
                          >
                            {selectionMode && (
                              <td className="px-4 py-4 w-10">
                                <input
                                  type="checkbox"
                                  disabled={!isSelectable(gift)}
                                  checked={selectedGiftIds.has(gift.id)}
                                  onChange={() => toggleSelectGift(gift.id)}
                                  className="h-4 w-4 rounded border-neutral-300 disabled:opacity-40"
                                  aria-label={`Seleccionar ${gift.name}`}
                                />
                              </td>
                            )}

                            <td className="px-6 py-4">
                              <div className="flex items-center">
                                {gift.image && (
                                  <img
                                    src={gift.image}
                                    alt={gift.name}
                                    className="h-10 w-10 rounded object-cover"
                                  />
                                )}
                                <div className="ml-4">
                                  <div className="text-sm font-medium text-neutral-900">
                                    {gift.name}
                                    {!gift.active && (
                                      <span className="ml-2 text-xs text-neutral-500">(Inactivo)</span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </td>

                            <td className="px-6 py-4 whitespace-nowrap">
                              <span className="text-sm text-neutral-600 capitalize">
                                {gift.category?.replace('-', ' ') || '-'}
                              </span>
                            </td>

                            <td className="px-6 py-4 whitespace-nowrap">
                              <span className="text-sm font-semibold text-neutral-900">
                                {formatPrice(gift.price)}
                              </span>
                            </td>

                            <td className="px-6 py-4 whitespace-nowrap">
                              {gift.reserved ? (
                                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                                  Recibido
                                </span>
                              ) : (
                                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800">
                                  Disponible
                                </span>
                              )}
                            </td>

                            <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                              {!gift.reserved && (
                                <>
                                  <button
                                    onClick={() => handleEditGift(gift)}
                                    className="text-accent-600 hover:text-accent-900 mr-3"
                                  >
                                    Editar
                                  </button>
                                  <button
                                    onClick={() => handleToggleActive(gift.id, gift.active)}
                                    className="text-blue-600 hover:text-blue-900 mr-3"
                                  >
                                    {gift.active ? 'Ocultar' : 'Mostrar'}
                                  </button>
                                  <button
                                    onClick={() => handleDeleteGift(gift.id)}
                                    className="text-red-600 hover:text-red-900"
                                  >
                                    Eliminar
                                  </button>
                                </>
                              )}
                              {gift.reserved && (
                                <span className="text-neutral-400 text-xs">No editable</span>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>

                    </table>
                  </div>
                </div>
              </>
            )}
          </div>
        )}


        {/* Received Gifts Tab */}

        {activeTab === 'received' && (
          <ReceivedTab
            gifts={gifts}
            couple={couple}
            loading={loadingGifts}
            loadingReceived={loadingReceived}
            onExportPDF={handleExportPDF}
            onSendThankYou={(gift, contributor) => {
              setSelectedGift(gift);
              setSelectedContributor(contributor);
              setShowThankYouModal(true);
            }}
            formatPrice={formatPrice}
            receivedTopRef={receivedTopRef}
          />
        )}



        {/* Seguridad Tab */}


        {/* {activeTab === 'security' && (
          <SecurityTab onChangePassword={() => setShowPasswordModal(true)} />
        )} */}

        {activeTab === 'security' && (
  <SecurityTab 
    onChangePassword={() => setShowPasswordModal(true)}
    couple={couple}
    onUpdatePrivacy={(newValue) => {
      setCouple(prev => ({ ...prev, isPublic: newValue }));
    }}
  />
)}
        {/* Banking Tab */}

        {activeTab === 'banking' && (
          <BankingTab
            couple={couple}
            onSave={handleSaveBanking}
          />
        )}
      </main>


      {/* <GiftFormModal
        isOpen={showGiftModal}
        editingGift={editingGift}
        formData={giftFormData}
        onFormChange={setGiftFormData}
        onSubmit={handleSaveGift}
        onClose={() => setShowGiftModal(false)}
      /> */}
      <GiftFormModal
        isOpen={showGiftModal}
        editingGift={editingGift}
        formData={giftFormData}
        onFormChange={setGiftFormData}
        onSubmit={handleSaveGift}
        onClose={() => setShowGiftModal(false)}
        coupleId={couple?.id} // ✅ AGREGAR ESTO
      />
      {/* Password Change Modal */}

      <PasswordChangeModal
        isOpen={showPasswordModal}
        formData={passwordFormData}
        onFormChange={setPasswordFormData}
        onSubmit={handleChangePassword}
        onClose={() => setShowPasswordModal(false)}
      />

      <ShareListModal
        isOpen={showShareModal}
        onClose={() => setShowShareModal(false)}
        couple={couple}
      />
      {/* Footer Simplificado */}

      <DashboardFooter
        couple={couple}
        onContactClick={() => setShowContactModal(true)}
      />
      {/* Contact Slideout */}
      <ContactSlideout
        isOpen={showContactModal}
        onClose={() => setShowContactModal(false)}
        couple={couple}
      />

      <OnboardingWizard
        isOpen={showOnboarding && !!couple}
        couple={couple}
        hasGifts={gifts.length > 0}
        onComplete={async () => {
          setShowOnboarding(false);
          await refreshGifts();
        }}
        onSkip={() => setShowOnboarding(false)}
      />
      <ThankYouModal
        isOpen={showThankYouModal}
        contributor={selectedContributor}
        gift={selectedGift}
        couple={couple}
        onThanked={refreshGifts} // ✅ CAMBIAR a refreshGifts
        onClose={() => {
          setShowThankYouModal(false);
          setSelectedContributor(null);
          setSelectedGift(null);
        }}
        formatPrice={formatPrice}
      />

      {toast && (
        <div className="fixed top-6 right-6 z-[80] w-[min(92vw,420px)] animate-toast-in">
          <div
            className={`rounded-2xl px-5 py-4 shadow-xl flex items-start justify-between gap-4
        ${toast.type === "success"
                ? "bg-green-600 text-white"
                : toast.type === "error"
                  ? "bg-red-600 text-white"
                  : "bg-neutral-900 text-white"
              }`}
          >
            <div>
              <p className="font-semibold">{toast.title}</p>
              <p className="text-sm mt-1 opacity-90">{toast.message}</p>
            </div>

            <button
              type="button"
              onClick={() => setToast(null)}
              className="rounded-xl bg-white/20 hover:bg-white/30 px-3 py-1 text-sm font-semibold"
            >
              ✕
            </button>
          </div>
        </div>
      )}

      {/* if (showOnboarding && couple) {
    return (
      <OnboardingWizard
        couple={couple}
        hasGifts={gifts.length > 0}
        onComplete={async () => {
          setShowOnboarding(false);
          // ✅ En lugar de recargar, refrescar gifts
          await refreshGifts();
        }}
        onSkip={() => {
          setShowOnboarding(false);
        }}
      />
    );
  } */}
    </div>

  );

};

export default CoupleDashboard;